import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { CourseFacade } from '../facades/course.facade';

export function courseCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const courseFacade = inject(CourseFacade);
        courseFacade.clear();

        return true;
    };
}
